export default {
  name: 'battery-level-indicator',
  props: {
    metadata: Object,
    size: {
      type: String,
      default: 'small'
    },
    showLabel: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    batteryLow () {
      return this.metadata && typeof this.metadata.battery_low === 'boolean' ? this.metadata.battery_low : null
    },
    isVisible () {
      return this.batteryLow !== null
    },
    statusLabel () {
      return this.batteryLow ? 'Low' : 'OK'
    },
    color () {
      return this.batteryLow ? 'error' : 'success'
    },
    iconClass () {
      return this.batteryLow ? 'far fa-battery-quarter' : 'far fa-battery-full'
    },
    avatarSize () {
      return this.size === 'large' ? 35 : 18
    },
    tooltip () {
      if (!this.isVisible) {
        return ''
      }

      const tooltipSegments = [`Battery: ${this.statusLabel}`]
      const batteryPct = this.metadata && typeof this.metadata.battery_pct === 'number' ? this.metadata.battery_pct : null
      if (batteryPct !== null) {
        tooltipSegments.push(`${batteryPct}%`)
      }

      let batteryMv = this.metadata && typeof this.metadata.battery_mv === 'number' ? this.metadata.battery_mv : null
      if (batteryMv === null && this.metadata && typeof this.metadata.battery_mv_avg === 'number') {
        batteryMv = this.metadata.battery_mv_avg
      }
      if (batteryMv !== null) {
        tooltipSegments.push(`${batteryMv} mV`)
      }

      const lastSeenAt = this.metadata && this.metadata.lastSeenAt ? new Date(this.metadata.lastSeenAt) : null
      if (lastSeenAt && !isNaN(lastSeenAt.getTime())) {
        tooltipSegments.push(`last seen ${lastSeenAt.toISOString()}`)
      }

      return tooltipSegments.join(' -- ')
    }
  }
}
